import React from 'react';
import { granularityToUnitAndFormat } from '../../RetailerReporting';
import { manufacturerOrModelBreakdownTooltip } from '../Devices';
import { NoDataMessage } from '../../NoDataMessage';
import Chart from 'react-google-charts';

export const DeviceEventGraphByType = ({ results, granularity, dates }) => {
    // Can't render a graph at all if there's nothing to plot.
    if (!results.length) {
        return <NoDataMessage />;
    }

    // Transform data.
    let [unit, format] = granularityToUnitAndFormat(granularity);
    let data = [
        [
            unit,
            'HVAC',
            { role: 'tooltip', type: 'string', p: { html: true } },
            'EV',
            { role: 'tooltip', type: 'string', p: { html: true } },
            'CS',
            { role: 'tooltip', type: 'string', p: { html: true } },
            'SI',
            { role: 'tooltip', type: 'string', p: { html: true } },
            'BAT',
            { role: 'tooltip', type: 'string', p: { html: true } },
            'SM',
            { role: 'tooltip', type: 'string', p: { html: true } },
            'INV',
            { role: 'tooltip', type: 'string', p: { html: true } },
            'OTHER',
            { role: 'tooltip', type: 'string', p: { html: true } },
        ],
    ];
    let hasNonZeroData = false;
    for (let datapoint of results) {
        if (datapoint.count > 0) {
            hasNonZeroData = true;
        }
        let hvac = 0,
            ev = 0,
            cs = 0,
            si = 0,
            bat = 0,
            sm = 0,
            inv = 0,
            other = 0;
        let hvacTooltip = 'No Breakdown',
            evTooltip = 'No Breakdown',
            csTooltip = 'No Breakdown',
            siTooltip = 'No Breakdown',
            batTooltip = 'No Breakdown',
            smTooltip = 'No Breakdown',
            invTooltip = 'No Breakdown',
            otherTooltip = 'No Breakdown';

        for (let type of datapoint.types) {
            switch (type.type) {
                case 'HVAC':
                    hvac += type.count;
                    hvacTooltip = manufacturerOrModelBreakdownTooltip(type.manufacturers);
                    break;
                case 'EV':
                    ev += type.count;
                    evTooltip = manufacturerOrModelBreakdownTooltip(type.manufacturers);
                    break;
                case 'CS':
                    cs += type.count;
                    csTooltip = manufacturerOrModelBreakdownTooltip(type.manufacturers);
                    break;
                case 'SI':
                    si += type.count;
                    siTooltip = manufacturerOrModelBreakdownTooltip(type.manufacturers);
                    break;
                case 'BAT':
                    bat += type.count;
                    batTooltip = manufacturerOrModelBreakdownTooltip(type.manufacturers);
                    break;
                case 'SM':
                    sm += type.count;
                    smTooltip = manufacturerOrModelBreakdownTooltip(type.manufacturers);
                    break;
                case 'INV':
                    inv += type.count;
                    invTooltip = manufacturerOrModelBreakdownTooltip(type.manufacturers);
                    break;
                case 'OTHER':
                    other += type.count;
                    otherTooltip = manufacturerOrModelBreakdownTooltip(type.manufacturers);
                    break;
                default:
                // Something we don't handle yet
            }
        }
        data.push([
            new Date(datapoint.start),
            hvac,
            hvacTooltip,
            ev,
            evTooltip,
            cs,
            csTooltip,
            si,
            siTooltip,
            bat,
            batTooltip,
            sm,
            smTooltip,
            inv,
            invTooltip,
            other,
            otherTooltip,
        ]);
    }

    // Display stacked bar chart.
    const options = {
        isStacked: true,
        hAxis: {
            format,
            slantedText: false,
            textStyle: {
                fontSize: 14,
            },
            ...(dates.length > 0 && { ticks: dates }),
        },
        vAxis: {
            format: '0',
            ...(hasNonZeroData ? {} : { viewWindow: { min: 0, max: 1 } }),
        },
        tooltip: {
            isHtml: true,
            trigger: 'selection',
        },
        chartArea: {
            height: '80%',
        },
    };
    return <Chart chartType="ColumnChart" width="100%" height="400px" data={data} options={options} />;
};
